import Velocity from 'velocity-animate';
import 'velocity-animate/velocity.ui.min';

class Accordion {
    constructor() {
        this.accordions = document.querySelectorAll('.js-accordion');
        if (this.accordions.length) {
            this.accordions.forEach((accordion) => {
                Accordion.bind(accordion);
            });
        }
    }

    static bind(accordion) {
        const items = accordion.querySelectorAll('.js-accordion-item');

        items.forEach((item) => {
            item.querySelector('.js-accordion-trigger').addEventListener('click', () => {
                const active = accordion.querySelector('.js-accordion-item.active');
                if (active) {
                    Velocity(active.querySelector('.js-accordion-content'), 'slideUp', {
                        duration: 200,
                        easing: 'easeInOutQuad',
                        complete: () => {
                        },
                    });
                }

                const isActive = item.classList.contains('active');

                items.forEach((otherItem) => {
                    otherItem.classList.remove('active');
                });

                if (!isActive) {
                    item.classList.add('active');
                    Velocity(item.querySelector('.js-accordion-content'), 'slideDown', { duration: 200, easing: 'easeInOutQuad' });
                }
            });
        });
    }
}

export default Accordion;
